"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 * @param {number} dateTime - Javascipt dateTime - 1667260800000
 * @returns Month Name
 */
var GetDateInfo = function GetDateInfo(dateTime) {
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    nth = function nth(date) {
      if (date > 3 && date < 21) return 'th';
      switch (date % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };
  var dateObj = new Date(),
    date,
    month,
    monthName,
    monthNameShort,
    year,
    day,
    dayNameShort,
    dayName,
    hour,
    minutes,
    seconds,
    datePrefix;
  if (dateTime) {
    dateObj = new Date(dateTime);
  }
  date = '0' + dateObj.getDate();
  date = date.slice(-2);
  datePrefix = nth(date);
  year = dateObj.getFullYear();
  month = dateObj.getMonth();
  monthName = months[month];
  monthNameShort = monthShort[month];
  month = '0' + (month + 1);
  month = month.slice(-2);
  day = dateObj.getDay();
  dayName = days[day];
  dayNameShort = daysShort[day];
  hour = dateObj.getHours();
  minutes = dateObj.getMinutes();
  seconds = dateObj.getSeconds();
  return {
    date: date,
    datePrefix: datePrefix,
    month: month,
    monthName: monthName,
    monthNameShort: monthNameShort,
    year: year,
    day: day,
    dayNameShort: dayNameShort,
    dayName: dayName,
    hour: hour,
    minutes: minutes,
    seconds: seconds
  };
};
var _default = exports["default"] = GetDateInfo;